module.exports = __webpack_public_path__ + "img/4.d3159309.png";